'use client';

import { Fulfillment } from '@instamenu/data-access';
import { useCheckoutContext } from '@instamenu/context-checkout';
import { Box, Text } from '@instamenu/ui-system-next';
import { observer } from 'mobx-react-lite';

export const NavbarTable = observer(() => {
  const checkout = useCheckoutContext();
  if (
    !checkout ||
    checkout.order.fulfillment === Fulfillment.Delivery ||
    (!checkout.order.isDineIn && !checkout.order.isPickupLocation)
  )
    return null;

  // Prefer the resolved table_mapping name (e.g. "Table 5") for display; fall
  // back to the raw code from the URL (e.g. "T5") when the restaurant doesn't
  // have a mapping configured.
  const tableName = checkout.order.tableMapping || checkout.order.table;
  if (!tableName) return null;

  return (
    <Box>
      <Text variant="body1" css={{ fontWeight: 700 }}>
        {checkout.order.isPickupLocation ? `Location: ${tableName}` : tableName}
      </Text>
    </Box>
  );
});
